import { Badge, Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { EventKindDto, EventListItemDto } from "../../../autogen/bff-api";
import { EventStatusTag } from "../../sourcing-events/EventStatusTag";
import { useEventNavigation } from "../../sourcing-events/useEventNavigation";
interface Props {
  event: EventListItemDto;
}

export const LatestEvent = ({ event }: Props) => {
  const navigateToEvent = useEventNavigation();

  return (
    <Flex
      key={event.id}
      w="100%"
      minHeight="50px"
      borderRadius={"6px"}
      mt="15px"
      padding={"10px"}
      backgroundColor="smBackgroundSecondary"
      cursor="pointer"
      _hover={{
        backgroundColor: "rgba(49, 151, 149, 0.08)",
      }}
      onClick={() => navigateToEvent(event)}
    >
      <Grid
        w="100%"
        key={event.id}
        gridTemplateAreas={`
            "title unresolved status"
            "sub unresolved status"
            `}
        gridTemplateColumns={"1fr minmax(100px, max-content) 140px"}
      >
        <GridItem area="title">
          <Flex flex={3} alignItems={"center"} paddingLeft="10px">
            <Text fontSize={"md"} color="smMuted">
              {event.title}
            </Text>
          </Flex>
        </GridItem>
        <GridItem area={"sub"}>
          <Flex flex={3} alignItems={"center"} paddingLeft="10px">
            <Text
              fontSize={"sm"}
              fontWeight={"light"}
              color="smMuted"
            >{`${event.createdBy.firstName} ${event.createdBy.lastName}`}</Text>
          </Flex>
        </GridItem>
        <GridItem area={"unresolved"} display="flex" alignItems="center" pr="10px">
          {event.unansweredQuestionsCount > 0 && (
            <Badge colorScheme="red" ml="6px" rounded="md" variant="solid">
              {event.unansweredQuestionsCount} {t("unresolved")}
            </Badge>
          )}
        </GridItem>
        <GridItem area="status" display="flex" flexDirection="column" alignItems="end" justifyContent="center">
          {event.kind === EventKindDto.Bse && event.bseStatus && (
            <EventStatusTag event={{ kind: "BSE", status: event.bseStatus }} />
          )}
          {event.negotiationRound && (
            <Text pt="1" fontSize="xs" fontWeight="semibold" color="smSecondary">
              {t("Negotiation round")} {event.negotiationRound}
            </Text>
          )}
        </GridItem>
      </Grid>
    </Flex>
  );
};
